function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createUseStyles } from 'react-jss';
var useHeaderLogoStyles = createUseStyles(function (_ref) {
  var _authDefaultA, _authLimited, _LogoText;
  var breakpoints = _ref.breakpoints,
    spacing = _ref.spacing,
    type = _ref.type;
  return {
    LogoLink: {
      margin: 'auto',
      textDecoration: 'none',
      '&:hover, &:focus': {
        textDecoration: 'none'
      },
      '&.anon--limited': _defineProperty({}, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        flexGrow: 1
      }),
      '&.auth--default, &.auth--limited': (_authDefaultA = {
        padding: spacing[1],
        margin: 'auto'
      }, _defineProperty(_authDefaultA, "@media (min-width: ".concat(breakpoints.md, "px)"), {
        padding: [spacing[1], 0, 0, spacing[7]],
        flexGrow: 1
      }), _defineProperty(_authDefaultA, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        padding: [spacing[1], 0, 0, spacing[1]]
      }), _authDefaultA),
      '&.auth--default': _defineProperty({}, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        flexGrow: 0
      }),
      '&.auth--limited': (_authLimited = {
        padding: spacing[2],
        margin: 'auto'
      }, _defineProperty(_authLimited, "@media (min-width: ".concat(breakpoints.md, "px)"), {
        padding: [spacing[2], 0, 0, spacing[7]],
        flexGrow: 1
      }), _defineProperty(_authLimited, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        padding: [spacing[2], 0, 0, spacing[1]]
      }), _authLimited)
    },
    LogoAuthIcon: {
      margin: spacing[3],
      fontSize: 34,
      fontWeight: type.fontWeight.light
    },
    LogoAnonIcon: _defineProperty({
      margin: 0,
      fontSize: 34,
      fontWeight: type.fontWeight.light
    }, "@media (min-width: ".concat(breakpoints.lg, "px)"), {
      display: 'none'
    }),
    LogoText: (_LogoText = {
      width: 160,
      height: 24,
      display: 'none'
    }, _defineProperty(_LogoText, "@media (min-width: ".concat(breakpoints.lg, "px)"), {
      display: 'inline-flex'
    }), _defineProperty(_LogoText, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
      width: 180,
      height: 36
    }), _LogoText)
  };
});
export default useHeaderLogoStyles;
//# sourceMappingURL=useHeaderLogoStyles.js.map